import React from "react";

const RenderValue = ({
  start_label,
  end_label,
  length,
  value,
  isParagraph,
  grow = true,
}: {
  start_label: any;
  end_label: any;
  length: number;
  value: any;
  isParagraph: boolean;
  /** false = ช่องกว้างคงที่ตาม length ไม่ยืดเต็มบรรทัด (สำหรับช่องสั้น ๆ ตามแบบฟอร์มกระดาษ) */
  grow?: boolean;
}) => {
  const hasValue = value !== null && value !== undefined && value !== "";
  // length 0 = แถวข้อความล้วน ไม่ต้องมีเส้น (พฤติกรรมเดิมของ dot string ว่าง)
  const showLine = length > 0 || hasValue;

  return (
    <>
      {start_label != null && (
        <span className={`rv-label ${isParagraph ? "ml-12" : ""}`}>
          {start_label}
        </span>
      )}
      {showLine && (
        <span
          className={`ellipsis-container${
            grow && length > 0 ? " ellipsis-grow" : ""
          }`}
        >
          <span className="ellipsis-data">
            <b>{value ?? ""}</b>
          </span>
          {/* dot string ล่องหน: กำหนดความกว้างขั้นต่ำของช่องตามค่า length เดิม */}
          <span className="ellipsis-dots" aria-hidden="true">
            {".".repeat(Math.max(length, 0))}
          </span>
        </span>
      )}
      {end_label != null && <span className="rv-label">{end_label}</span>}
    </>
  );
};

export default RenderValue;
